'use strict';

(function () {
  'use strict';

  /**
   * Factory to set focus on the element with the given id.
   */

  angular.module('msCore').factory('focus', Focus);

  Focus.$inject = ['$timeout', '$window'];

  /* @ngInject */
  function Focus($timeout, $window) {
    return {
      byId: byId,
      byClassName: byClassName
    };

    // timeout makes sure that it is invoked after any other event has been triggered.
    // e.g. click events that need to run before the focus or
    // inputs elements that are in a disabled state but are enabled when those events
    // are triggered.
    // timeout does not wait for async calls so plan accordingly.

    function byId(id, delay) {
      $timeout(function () {
        var element = $window.document.getElementById(id);
        if (element) {
          element.focus();
        }
      }, delay || 0);
    }

    function byClassName(className, delay) {
      $timeout(function () {
        var element = angular.element(document.querySelector(className));
        if (element) {
          element.focus();
        }
      }, delay || 0);
    }
  }
})();